<section class="aca-mig__card aca-mig__cardpad">
  <label class="aca-mig__field" style="max-width: 420px">
    <span class="aca-mig__label">{{ 'DMS.MIGRATION.VALID_PICK_JOB' | translate }}</span>
    <select class="aca-mig__select" [ngModel]="selectedId()" (ngModelChange)="pick($event)">
      <option value="" disabled>{{ 'DMS.MIGRATION.PICK_JOB' | translate }}</option>
      <option *ngFor="let j of jobs()" [value]="j.id">{{ j.name }}</option>
    </select>
  </label>

  <div class="aca-mig__empty" *ngIf="!job">
    <mat-icon>fact_check</mat-icon>
    <div>{{ 'DMS.MIGRATION.VALID_EMPTY' | translate }}</div>
  </div>

  <ng-container *ngIf="job">
    <!-- summary -->
    <div class="aca-mig__stats" style="grid-template-columns: repeat(3, minmax(120px, 180px))">
      <div class="aca-mig__stat">
        <div class="aca-mig__statlabel">{{ 'DMS.MIGRATION.V_PASSED' | translate }}</div>
        <div class="aca-mig__statvalue">{{ passCount() }}</div>
      </div>
      <div class="aca-mig__stat">
        <div class="aca-mig__statlabel">{{ 'DMS.MIGRATION.V_WARNINGS' | translate }}</div>
        <div class="aca-mig__statvalue">{{ warnCount() }}</div>
      </div>
      <div class="aca-mig__stat">
        <div class="aca-mig__statlabel">{{ 'DMS.MIGRATION.V_ERRORS' | translate }}</div>
        <div class="aca-mig__statvalue">{{ errorCount() }}</div>
      </div>
    </div>

    <!-- client-side checks -->
    <h4 class="aca-mig__conncat">{{ 'DMS.MIGRATION.V_LOCAL_TITLE' | translate }}</h4>
    <div class="aca-mig__tablewrap">
      <table class="aca-mig__table">
        <tbody>
          <tr class="aca-mig__row" *ngFor="let r of clientChecks(); trackBy: trackByRow">
            <td class="aca-mig__td" style="width: 130px">
              <span
                class="aca-mig__chip"
                [ngClass]="r.level === 'pass' ? 'aca-mig__chip--ok' : r.level === 'warn' ? 'aca-mig__chip--warn' : 'aca-mig__chip--fail'"
              >
                {{ ('DMS.MIGRATION.VLEVEL_' + r.level.toUpperCase()) | translate }}
              </span>
            </td>
            <td class="aca-mig__td">{{ r.labelKey | translate }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- engine checks -->
    <h4 class="aca-mig__conncat">{{ 'DMS.MIGRATION.V_SERVER_TITLE' | translate }}</h4>
    <p class="aca-mig__notice" *ngIf="api.available() !== true">
      <mat-icon>cloud_off</mat-icon>
      <span>{{ 'DMS.MIGRATION.V_SERVER_DOWN' | translate }}</span>
    </p>

    <div class="aca-mig__tablewrap" *ngIf="api.available() !== true">
      <table class="aca-mig__table">
        <tbody>
          <tr class="aca-mig__row" *ngFor="let c of serverChecks; trackBy: trackByRow">
            <td class="aca-mig__td" style="width: 130px">
              <span class="aca-mig__chip">{{ 'DMS.MIGRATION.VLEVEL_UNVERIFIED' | translate }}</span>
            </td>
            <td class="aca-mig__td">{{ c.labelKey | translate }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="api.available() === true">
      <button type="button" class="aca-mig__btn aca-mig__btn--primary" [disabled]="serverBusy()" (click)="runServerValidation()">
        {{ 'DMS.MIGRATION.V_RUN' | translate }}
      </button>
      <pre class="aca-mig__mono" *ngIf="serverResult()" style="white-space: pre-wrap">{{ serverResult() | json }}</pre>
    </div>
  </ng-container>
</section>
